import * as locales from 'locales';
export const appLocales = locales;
